/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Ccsl_TitleInputs */

const en_file_export_ccsl_title = /** @type {(inputs: File_Export_Ccsl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL`)
};

const fr_file_export_ccsl_title = /** @type {(inputs: File_Export_Ccsl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL`)
};

const de_file_export_ccsl_title = /** @type {(inputs: File_Export_Ccsl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL`)
};

const it_file_export_ccsl_title = /** @type {(inputs: File_Export_Ccsl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL`)
};

const ru_file_export_ccsl_title = /** @type {(inputs: File_Export_Ccsl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL`)
};

const es_file_export_ccsl_title = /** @type {(inputs: File_Export_Ccsl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL`)
};

const zh_cn2_file_export_ccsl_title = /** @type {(inputs: File_Export_Ccsl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL`)
};

const ja_file_export_ccsl_title = /** @type {(inputs: File_Export_Ccsl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL`)
};

const hi_file_export_ccsl_title = /** @type {(inputs: File_Export_Ccsl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सीसीएसएल`)
};

const pt_pt2_file_export_ccsl_title = /** @type {(inputs: File_Export_Ccsl_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL`)
};

/**
* | output |
* | --- |
* | "CCSL" |
*
* @param {File_Export_Ccsl_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_ccsl_title = /** @type {((inputs?: File_Export_Ccsl_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Ccsl_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_ccsl_title(inputs)
	if (locale === "de") return de_file_export_ccsl_title(inputs)
	if (locale === "it") return it_file_export_ccsl_title(inputs)
	if (locale === "ru") return ru_file_export_ccsl_title(inputs)
	if (locale === "es") return es_file_export_ccsl_title(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_ccsl_title(inputs)
	if (locale === "ja") return ja_file_export_ccsl_title(inputs)
	if (locale === "hi") return hi_file_export_ccsl_title(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_ccsl_title(inputs)
	return en_file_export_ccsl_title(inputs)
});